// Removes the pre-React boot splash defined in public/index.html. Called once the app has
// locale + translations and is about to paint real content, so the splash covers the whole
// cold-start gap (bundle download through locale/i18n init) with no blank-screen flash.
export function hideBootLoader () {
  const el = document.getElementById('bb-boot-loader');
  if (!el) {
    return;
  }
  // fade out, then drop from the DOM so it can't trap clicks or linger for screen readers.
  el.classList.add('bb-boot-hide');
  setTimeout(() => el.remove(), 400);
}
